import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SafetyPay from "./pages/SafetyPay";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SafetyPay />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
